export const BACK_BUTTON_SLOT_WIDTH = 67

export const pageHeaderHorizontalPadding = theme => ({
  paddingLeft: theme.spacing(5),
  paddingRight: theme.spacing(3),
  [theme.breakpoints.down('xs')]: {
    paddingLeft: theme.spacing(2),
  },
})

export const pageHeaderLabelColumn = (theme, hasCrumbs) => ({
  minWidth: 0,
  paddingLeft: hasCrumbs ? theme.spacing(2) : 0,
  borderLeftStyle: hasCrumbs ? 'solid' : 'none',
  borderLeftWidth: hasCrumbs ? '1px' : 0,
  borderLeftColor: hasCrumbs ? theme.palette.grey[400] : 'transparent',
  [theme.breakpoints.down('xs')]: {
    paddingLeft: theme.spacing(2),
  },
})

export const pageHeaderGridColumns = hasCrumbs =>
  hasCrumbs ? `${BACK_BUTTON_SLOT_WIDTH}px minmax(0, 1fr)` : 'minmax(0, 1fr)'

export const pageHeaderGridColumnsWithActions = hasCrumbs =>
  hasCrumbs
    ? `${BACK_BUTTON_SLOT_WIDTH}px minmax(0, 1fr) auto`
    : 'minmax(0, 1fr) auto'

export const pageHeaderLabelColumnIndex = hasCrumbs => (hasCrumbs ? 2 : 1)

export const pageHeaderActionsColumnIndex = hasCrumbs => (hasCrumbs ? 3 : 2)
